import * as yup from 'yup';
import { addBatchAttachmentFormFields } from '../../fields/formFields';

export const addBatchAttachmentFormSchema = yup.object({
  [addBatchAttachmentFormFields.batchAttachmentType]: yup.number().positive().required('Attachment type is required'),
  [addBatchAttachmentFormFields.documentLink]: yup.string().required('Document Link is required').trim(),
});
